const o = {
  buySkin:
    "function buySkin(string memory name, uint256 qty, string memory token) public",
};

export default o;
